import { render, staticRenderFns } from "./single_project.vue?vue&type=template&id=175526a5&scoped=true&"
import script from "./single_project.vue?vue&type=script&lang=ts&"
export * from "./single_project.vue?vue&type=script&lang=ts&"
import style0 from "./single_project.vue?vue&type=style&index=0&id=175526a5&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "175526a5",
  null
  
)

export default component.exports